export default {
    activeGoldsmithItem: localStorage.getItem('activeGoldsmithItem') || null,
    noWeightLeft: false,
    allGoldsmithItemsAreOk: false
}